<template>
  <main
    class="account-page"
    :class="{ jp: $region === 'jp', sea: $area === 'komoe-sea' }"
  >
    <!-- <div class="-Topbar"></div> -->
    <transition name="fade">
      <section class="mask" v-if="showCodeImg">
        <section class="pop-modal">
          <div class="modal-head">
            <div class="modal-tit">
              <span class="tit-border"></span>
              {{ $t("login.pleaseInsertGraph") }}
              <svg
                @click="closeModal"
                class="close-icon"
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <path
                    d="M18.3192564,1.6807436 L10,10 L18.3192564,18.3192564 L10,10 L1.6807436,18.3192564 L10,10 L1.6807436,1.6807436 L10,10 L18.3192564,1.6807436 Z M10,7.6230696 L17.1307912,0.492278404 C17.7871624,-0.164092801 18.8513504,-0.164092801 19.5077216,0.492278404 C20.1640928,1.14864961 20.1640928,2.2128376 19.5077216,2.8692088 L12.3769304,10 L19.5077216,17.1307912 C20.1640928,17.7871624 20.1640928,18.8513504 19.5077216,19.5077216 C18.8513504,20.1640928 17.7871624,20.1640928 17.1307912,19.5077216 L10,12.3769304 L2.8692088,19.5077216 C2.2128376,20.1640928 1.14864961,20.1640928 0.492278404,19.5077216 C-0.164092801,18.8513504 -0.164092801,17.7871624 0.492278404,17.1307912 L7.6230696,10 L0.492278404,2.8692088 C-0.164092801,2.2128376 -0.164092801,1.14864961 0.492278404,0.492278404 C1.14864961,-0.164092801 2.2128376,-0.164092801 2.8692088,0.492278404 L10,7.6230696 Z"
                    id="path-1"
                  />
                </defs>
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1" />
                  </mask>
                  <use
                    id="Combined-Shape"
                    fill="#979797"
                    fill-rule="nonzero"
                    xlink:href="#path-1"
                  />
                  <g id="colour/#CCCCCC" mask="url(#mask-2)" fill="#CCCCCC">
                    <rect id="colour" x="0" y="0" width="20" height="20" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div class="modal-form">
            <el-form style=" top: 0px;">
              <!-- 手机号圆形验证码 -->
              <el-form-item v-if="accountType === 'phone'">
                <el-input
                  class="phone-input jp"
                  v-model="phoneCaptcha"
                  :placeholder="$t('login.pleaseInsertGraph')"
                ></el-input>
                <span
                  class="code-tip modal-code"
                  :class="{ jp: $region === 'jp' }"
                  @click="getimgCode1"
                >
                  <img :src="codeImg1" />
                </span>
              </el-form-item>
              <!-- 邮箱圆形验证码 -->
              <el-form-item v-if="accountType === 'email'">
                <el-input
                  class="phone-input jp"
                  v-model="emailCaptcha"
                  :placeholder="$t('login.pleaseInsertGraph')"
                ></el-input>
                <span
                  class="code-tip modal-code"
                  :class="{ jp: $region === 'jp' }"
                  @click="getimgCode1"
                >
                  <img :src="codeImg1" />
                </span>
              </el-form-item>
            </el-form>
            <div
              class="login-box-bot"
              :style="{ 'margin-top': $region === 'jp' ? '0px' : '40px' }"
            >
              <div class="login-btn allowed" @click="sendSms">
                {{ $t("signup.confirm") }}
              </div>
            </div>
          </div>
        </section>
      </section>
    </transition>
    <div class="main-container">
      <main-title
        class="change-maintitle"
        v-if="$area === 'komoe-sea'"
        :title="$t('account.accountSetting')"
      ></main-title>

      <div class="tab-menu" :class="{ jp: $region === 'jp' }">
        <template v-if="$area !== 'komoe-sea'">
          <p class="bui-title">{{ $t("account.accountSetting") }}</p>
          <p class="bui-title-little">{{ $t("account.uppercaseAccount") }}</p>
          <div
            class="tab tab1"
            v-if="
              $region === 'jp' || ($area === 'komoe' && gameVersionStatus === 0)
            "
            @click="changeModel(true)"
            :class="{ active: changeTab }"
          >
            <span></span>
            <span>{{ $t("account.changeBindingNumber") }}</span>
          </div>
        </template>
        <div
          class="tab tab2"
          @click="changeModel(false)"
          :class="{ active: !changeTab }"
        >
          <span></span>
          <span>{{ $t("account.changePwd") }}</span>
        </div>
      </div>
      <!-- komoe东南亚不提供绑定手机 -->
      <div
        class="bui-container change-bind"
        :class="{ jp: $region === 'jp' }"
        v-show="
          changeTab &&
            ($region === 'jp' || ($area === 'komoe' && gameVersionStatus === 0))
        "
      >
        <div class="top-nav" :class="{ jp: $region === 'jp' }">
          <span class="active">
            1
            <u>{{ $t("account.verifyPerson") }}</u>
          </span>
          <i :class="{ active: form2 || result1 }"></i>
          <span :class="{ active: form2 || result1 }">
            2
            <u>{{ $t("account.bindAccount") }}</u>
          </span>
          <i :class="{ active: result1 }"></i>
          <span :class="{ active: result1 }">
            3
            <u>{{ $t("account.bindEnd") }}</u>
          </span>
        </div>
        <!-- 表单1 -->
        <el-form
          :model="ruleForm1"
          :rules="rules"
          ref="ruleForm1"
          v-show="form1"
        >
          <!-- 默认手机号 -->
          <el-form-item prop="defaultPhone" v-if="accountType === 'phone'">
            <el-input
              v-model.number="ruleForm1.defaultPhone"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <!-- 默认邮箱 -->
          <el-form-item prop="defaultEmail" v-if="accountType === 'email'">
            <el-row>
              <el-col :span="7">
                <span>{{ $t("account.primaryEmail") }}</span>
              </el-col>
              <el-col :span="17">
                <el-input
                  v-model="ruleForm1.defaultEmail"
                  :disabled="true"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 手机号圆形验证码 -->
          <!-- <el-form-item v-if="accountType === 'phone'">
            <el-input
              class="phone-input jp"
              v-model="phoneCaptcha"
              :placeholder="$t('login.pleaseInsertGraph')"
            ></el-input>
            <span
              class="code-tip modal-code"
              :class="{ jp: $region === 'jp' }"
              @click="getimgCode1"
            >
              <img :src="codeImg1" />
            </span>
          </el-form-item> -->
          <!-- 邮箱圆形验证码 -->
          <!-- <el-form-item v-if="accountType === 'email'">
            <el-input
              class="phone-input jp"
              v-model="emailCaptcha"
              :placeholder="$t('login.pleaseInsertGraph')"
            ></el-input>
            <span
              class="code-tip modal-code"
              :class="{ jp: $region === 'jp' }"
              @click="getimgCode1"
            >
              <img :src="codeImg1" />
            </span>
          </el-form-item> -->
          <!-- 手机号获取验证码 -->
          <el-form-item prop="code" ref="code" v-if="accountType === 'phone'">
            <el-input
              v-model="ruleForm1.code"
              :placeholder="$t('account.pleaseInsertCode')"
            ></el-input>
            <span
              class="code-tip"
              @click="getCode(2)"
              :class="{ notAllowed: !sendFlag, jp: $region === 'jp' }"
              ga-data="1101001"
              >{{ btnMsg }}</span
            >
          </el-form-item>
          <!-- 邮箱获取验证码 -->
          <el-form-item
            prop="emailCode"
            ref="emailCode"
            v-if="accountType === 'email'"
          >
            <el-row>
              <el-col :span="7">
                <span>{{ $t("account.codeLabel") }}</span>
              </el-col>
              <el-col :span="17">
                <el-input
                  v-model="ruleForm1.emailCode"
                  :placeholder="$t('account.pleaseInsertCode')"
                ></el-input>
                <span
                  class="code-tip"
                  @click="getCode(2)"
                  :class="{ notAllowed: !sendFlag, jp: $region === 'jp' }"
                  >{{ btnMsg }}</span
                >
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 第一次下一步 -->
          <div
            class="btn-next"
            :class="{ allowed: submitReady1 }"
            @click="checkSms(2)"
            ga-data="1101002"
          >
            <span>{{ $t("account.next") }}</span>
          </div>
        </el-form>
        <!-- 表单2 -->
        <!--  -->
        <el-form
          v-show="form2"
          :model="ruleForm2"
          :rules="rules"
          ref="ruleForm2"
        >
          <el-form-item prop="phone" v-if="accountType === 'phone'">
            <k-select
              :selected="selected"
              :options="codeList"
              @selectedOption="selectOption"
              class="code-area"
            ></k-select>
            <el-input
              class="phone-input"
              v-model.number="ruleForm2.phone"
              :placeholder="$t('account.insertMobile')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email" v-if="accountType === 'email'">
            <el-input
              class="phone-input jp"
              v-model="ruleForm2.email"
              :placeholder="$t('account.insertEmail')"
            ></el-input>
          </el-form-item>
          <!-- 手机号圆形验证码 -->
          <!-- <el-form-item v-if="accountType === 'phone'">
            <el-input
              class="phone-input jp"
              v-model="phoneCaptcha"
              :placeholder="$t('login.pleaseInsertGraph')"
            ></el-input>
            <span
              class="code-tip modal-code"
              :class="{ jp: $region === 'jp' }"
              @click="getimgCode1"
            >
              <img :src="codeImg1" />
            </span>
          </el-form-item> -->
          <!-- 邮箱圆形验证码 -->
          <!-- <el-form-item v-if="accountType === 'email'">
            <el-input
              class="phone-input jp"
              v-model="emailCaptcha"
              :placeholder="$t('login.pleaseInsertGraph')"
            ></el-input>
            <span
              class="code-tip modal-code"
              :class="{ jp: $region === 'jp' }"
              @click="getimgCode1"
            >
              <img :src="codeImg1" />
            </span>
          </el-form-item> -->
          <el-form-item prop="code" ref="code">
            <el-input
              v-model="ruleForm2.code"
              :placeholder="$t('account.pleaseInsertCode')"
            ></el-input>
            <span
              class="code-tip"
              @click="getCode(3)"
              :class="{ notAllowed: !sendFlag, jp: $region === 'jp' }"
              >{{ btnMsg }}</span
            >
          </el-form-item>
          <div
            class="btn-next"
            :class="{ allowed: submitReady2 }"
            @click="submitNewTel()"
            ga-data="1102002"
          >
            <span>{{ $t("account.next") }}</span>
          </div>
        </el-form>
        <!--绑定-->
        <div class="result" v-show="result1">
          <div class="text">
            <span class="icon"></span>
            <span>{{ $t("account.bindingMobSuccess") }}</span>
          </div>
          <a
            class="go-home"
            :class="{ jp: $region === 'jp' }"
            :href="$siteConfig.domain"
            ga-data="1103002"
            v-if="accountType === 'phone'"
          >
            <span class="icon"></span>
            <span>{{ $t("account.backHome") }}</span>
          </a>
          <a
            class="go-home"
            :class="{ jp: $region === 'jp' }"
            :href="$siteConfig.domain"
            v-if="accountType === 'email'"
          >
            <span class="icon"></span>
            <span>{{ $t("account.backHome") }}</span>
          </a>
        </div>
      </div>

      <!--修改密码-->
      <div
        class="bui-container change-pwd"
        :class="{ jp: $region === 'jp' }"
        v-show="!changeTab"
      >
        <div
          class="top-nav"
          v-if="$region === 'jp'"
          :class="{ jp: $region === 'jp' }"
        >
          <span class="active">
            1
            <u>{{ $t("account.verifyPerson") }}</u>
          </span>
          <i :class="{ active: form4 || result2 }"></i>
          <span :class="{ active: form4 || result2 }">
            2
            <u>{{ $t("account.setPwd") }}</u>
          </span>
          <i :class="{ active: result2 }"></i>
          <span :class="{ active: result2 }">
            3
            <u>{{ $t("account.setSuccess") }}</u>
          </span>
        </div>
        <!-- <div class="top-nav" v-else :class="{'jp': $region === 'jp'}">
          <span :class="{'active': form4 || result2}">
            1
            <u>{{$t('account.setPwd')}}</u>
          </span>
          <i :class="{'active': form4 || result2}"></i>
          <i :class="{'active': result2}"></i>
          <span :class="{'active': result2}">
            2
            <u>{{$t('account.setSuccess')}}</u>
          </span>
        </div> -->

        <!-- 表单3 -->
        <el-form
          :model="ruleForm3"
          :rules="rules"
          ref="ruleForm3"
          v-show="form3"
        >
          <el-form-item prop="defaultPhone" v-if="accountType === 'phone'">
            <el-input
              v-model.number="ruleForm3.defaultPhone"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item prop="primaryEmail" v-if="accountType === 'email'">
            <el-row>
              <el-col :span="7">
                <span>{{ $t("account.primaryEmail") }}</span>
              </el-col>
              <el-col :span="17">
                <el-input
                  v-model="ruleForm3.defaultEmail"
                  :disabled="true"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <!-- 手机号圆形验证码 -->
          <!-- <el-form-item v-if="accountType === 'phone'">
            <el-input
              class="phone-input jp"
              v-model="phoneCaptcha"
              :placeholder="$t('login.pleaseInsertGraph')"
            ></el-input>
            <span
              class="code-tip modal-code"
              :class="{ jp: $region === 'jp' }"
              @click="getimgCode1"
            >
              <img :src="codeImg1" />
            </span>
          </el-form-item> -->
          <!-- 邮箱圆形验证码 -->
          <!-- <el-form-item v-if="accountType === 'email' && $area !== 'komoe-sea'">
            <el-input
              class="phone-input jp"
              v-model="emailCaptcha"
              :placeholder="$t('login.pleaseInsertGraph')"
            ></el-input>
            <span
              class="code-tip modal-code"
              :class="{ jp: $region === 'jp' }"
              @click="getimgCode1"
            >
              <img :src="codeImg1" />
            </span>
          </el-form-item> -->

          <el-form-item prop="code" ref="code" v-if="accountType === 'phone'">
            <el-input
              v-model="ruleForm3.code"
              :placeholder="$t('account.pleaseInsertCode')"
            ></el-input>
            <span
              class="code-tip"
              @click="getCode(4)"
              :class="{ notAllowed: !sendFlag }"
              ga-data="1201001"
              >{{ btnMsg }}</span
            >
          </el-form-item>
          <el-form-item
            prop="emailCode"
            ref="emailCode"
            v-if="accountType === 'email'"
          >
            <el-row>
              <el-col :span="7">
                <span>{{ $t("account.codeLabel") }}</span>
              </el-col>
              <el-col :span="17">
                <el-input
                  v-model="ruleForm3.emailCode"
                  :placeholder="$t('account.pleaseInsertCode')"
                ></el-input>
                <span
                  class="code-tip"
                  @click="getCode(4)"
                  :class="{ notAllowed: !sendFlag, jp: $region === 'jp' }"
                  v-if="$area !== 'komoe-sea'"
                  >{{ btnMsg }}</span
                >

                <!-- komoe东南亚这里使用图形进行验证 -->
                <span
                  class="code-tip email-code"
                  v-else
                  :class="{ jp: $region === 'jp' }"
                  @click="getImgCode"
                >
                  <img :src="codeImg" />
                </span>
              </el-col>
            </el-row>
          </el-form-item>
          <div
            class="btn-next"
            :class="{ allowed: submitReady3 }"
            @click="checkSms(4)"
            ga-data="1201002"
            v-if="$region !== 'komoe'"
          >
            <span>{{ $t("account.next") }}</span>
          </div>

          <div
            class="btn-next"
            :class="{ allowed: submitReady3 }"
            @click="checkSms(5)"
            ga-data="1201002"
            v-else
          >
            <span>{{ $t("account.next") }}</span>
          </div>
        </el-form>
        <!-- 表单4 -->
        <el-form
          :model="ruleForm4"
          :rules="rules"
          ref="ruleForm4"
          v-show="form4"
        >
          <div v-if="$area === 'komoe'" class="changePwdTitle">
            {{ $t("account.changePwd") }}
          </div>
          <!-- 手机号账号 -->
          <el-form-item prop="password1" v-if="accountType === 'phone'">
            <el-input
              type="password"
              v-model="ruleForm4.password1"
              :placeholder="$t('account.currentPwd')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password2" v-if="accountType === 'phone'">
            <el-input
              type="password"
              v-model="ruleForm4.password2"
              :placeholder="$t('account.newPwd')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password3" v-if="accountType === 'phone'">
            <el-input
              type="password"
              v-model="ruleForm4.password3"
              :placeholder="$t('account.reinsertPwd')"
            ></el-input>
          </el-form-item>
          <!-- 邮箱账号 -->
          <el-form-item prop="emailCurrentPwd" v-if="accountType === 'email'">
            <el-row>
              <el-col :span="$area === 'komoe-sea' ? 8 : 7">
                <span>{{ $t("account.currentPwd") }}</span>
              </el-col>
              <el-col :span="$area === 'komoe-sea' ? 16 : 17">
                <el-input
                  type="password"
                  v-model="ruleForm4.emailCurrentPwd"
                  :placeholder="$t('account.currentPwd')"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="emailNewPwd" v-if="accountType === 'email'">
            <el-row>
              <el-col :span="$area === 'komoe-sea' ? 8 : 7">
                <span>{{ $t("account.newPwd") }}</span>
              </el-col>
              <el-col :span="$area === 'komoe-sea' ? 16 : 17">
                <el-input
                  type="password"
                  v-model="ruleForm4.emailNewPwd"
                  :placeholder="$t('account.newPwd')"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item prop="emailReinsertPwd" v-if="accountType === 'email'">
            <el-row>
              <el-col :span="$area === 'komoe-sea' ? 8 : 11">
                <span>{{ $t("account.reinsertPwd") }}</span>
              </el-col>
              <el-col :span="$area === 'komoe-sea' ? 16 : 13">
                <el-input
                  type="password"
                  v-model="ruleForm4.emailReinsertPwd"
                  :placeholder="$t('account.reinsertPwd')"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <div
            v-if="accountType === 'phone'"
            class="btn-next"
            :class="{ allowed: submitReady4 }"
            @click="submitNewPwd()"
            ga-data="1202001"
          >
            <span>{{ $t("account.next") }}</span>
          </div>
          <div
            v-if="accountType === 'email'"
            class="btn-next"
            :class="{ allowed: submitReady4 }"
            @click="submitNewPwd()"
          >
            <span>{{ $t("account.next") }}</span>
          </div>
        </el-form>
        <div class="result" v-show="result2">
          <div class="text">
            <span class="icon"></span>
            <span>{{ $t("account.changePwdSuccess") }}</span>
          </div>
          <p v-if="accountType === 'email'">
            {{ $t("account.pleaseRelogin") }}
          </p>
          <p v-if="accountType === 'phone'">
            {{ count }}s{{ $t("account.password_modify_success_message")
            }}<span class="handBack" @click="backPage">{{
              $t("account.password_modify_success_action")
            }}</span>
          </p>
          <!-- <a
            class="go-home"
            :class="{jp: $region === 'jp'}"
            :href="$siteConfig.domain"
            ga-data="1203001"
            v-if="accountType === 'phone'"
          >
            <span class="icon"></span>
            <span>{{$t('account.backHome')}}</span>
          </a> -->
          <router-link
            v-if="accountType === 'email'"
            to="/login"
            class="go-home jp"
          >
            <span class="icon"></span>
            <span>{{ $t("account.relogin") }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <error-modal
      :msg="errorMsg"
      @closeModal="closeErrorModal"
      v-if="errorFlag"
    ></error-modal>
    <!-- 底通 -->
    <!-- <div class="-Footer"> -->
    <!-- <div class="footer-logo"></div>
      <ul class="footer-copyright"></ul>-->
    <!-- </div> -->
  </main>
</template>

<script>
import JSEncrypt from "jsencrypt";
import Vue from "vue";
import store from "@/store";
import { Input, FormItem, Form, Select, Option, Row, Col } from "element-ui";
import kSelect from "@/component/select/select.vue";
import mainTitle from "@/component/mainTit/index.vue";
import ErrorModal from "@/component/modal/error.vue";
Vue.use(Input);
Vue.use(FormItem);
Vue.use(Form);
Vue.use(Select);
Vue.use(Option);
Vue.use(Row);
Vue.use(Col);

export default {
  name: "account",
  components: {
    kSelect,
    mainTitle,
    ErrorModal,
  },
  data() {
    var vm = this;
    var validPhone = (rule, value, callback) => {
      value += "";
      if (!value) {
        callback(new Error(vm.$t("account.insertPhone")));
      } else {
        if (!value.match("^[0-9]{5,12}$")) {
          callback(new Error(vm.$t("account.insertCorrectPhone")));
        } else {
          callback();
        }
      }
    };
    var validEmail = (rule, value, callback) => {
      const emailPattern = /\w[-\w.+]*@([-A-Za-z0-9]+\.)+([A-Za-z0-9][-A-Za-z0-9]+\.)?[A-Za-z]{2,14}$/;
      value += "";
      if (!value) {
        return callback(new Error(vm.$t("account.insertEmail")));
      } else {
        if (!emailPattern.test(value)) {
          return callback(vm.$t("account.insertCorrectEmail"));
        }
        return callback();
      }
    };
    var validCode = (rule, value, callback) => {
      value += "";
      if (!value) {
        callback(new Error(vm.$t("account.pleaseInsertCode")));
      } else {
        callback();
      }
    };
    var validpassword1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("account.insertOldPwd")));
      } else {
        callback();
      }
    };
    var validpassword2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("account.insertNewPwd")));
      } else if (value == this.ruleForm4.password1) {
        callback(new Error(vm.$t("account.shouldNotSame")));
      } else {
        callback();
      }
    };
    var validpassword3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("account.reinsertNewPwd")));
      } else if (value !== this.ruleForm4.password2) {
        callback(new Error(vm.$t("account.differentPassword")));
      } else {
        callback();
      }
    };
    var validEmailPassword1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("account.insertOldPwd")));
      } else {
        callback();
      }
    };
    var validEmailPassword2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("account.insertNewPwd")));
      } else if (value == this.ruleForm4.emailCurrentPwd) {
        callback(new Error(vm.$t("account.shouldNotSame")));
      } else {
        callback();
      }
    };
    var validEmailPassword3 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(vm.$t("account.reinsertNewPwd")));
      } else if (value !== this.ruleForm4.emailNewPwd) {
        callback(new Error(vm.$t("account.differentPassword")));
      } else {
        callback();
      }
    };

    return {
      accountType:
        this.$region === "jp" || this.$area == "komoe-sea" ? "email" : "phone",
      changeTab:
        this.$region === "jp" ||
        (this.$area === "komoe" &&
          Number(window.localStorage.getItem("gameVersionStatus")) === 0)
          ? true
          : false,
      gameVersionStatus: Number(
        window.localStorage.getItem("gameVersionStatus")
      ),
      // 更改绑定账号-输入验证码表单
      form1: true,
      form2: false,
      // 修改密码-输入验证码表单
      form3: true,
      form4: false,
      // 控制更换绑定号码结果
      result1: false,
      result2: false,
      phoneCaptcha: "",
      emailCaptcha: "",
      selected: {
        val: "",
        id: "",
      },
      codeList: [],
      ruleForm1: {
        defaultPhone: "",
        defaultEmail: "",
        code: "",
        emailCode: "",
        captcha: "",
        captcha1: "",
      },
      ruleForm2: {
        phone: "",
        code: "",
        email: "",
        captcha: "",
      },
      ruleForm3: {
        defaultPhone: "",
        defaultEmail: "",
        code: "",
        emailCode: "",
      },
      ruleForm4: {
        password1: "",
        password2: "",
        password3: "",
        emailCurrentPwd: "",
        emailNewPwd: "",
        emailReinsertPwd: "",
      },
      rules: {
        phone: [
          {
            validator: validPhone,
            trigger: "blur",
          },
        ],
        defaultEmail: [
          {
            validator: validEmail,
            trigger: "blur",
          },
        ],
        email: [
          {
            validator: validEmail,
            trigger: "blur",
          },
        ],
        code: [
          {
            validator: validCode,
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            validator: validCode,
            trigger: "blur",
          },
        ],
        password1: [
          {
            validator: validpassword1,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: this.$t("account.pwdRule1"),
            trigger: "blur",
          },
        ],
        password2: [
          {
            validator: validpassword2,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: this.$t("account.pwdRule1"),
            trigger: "blur",
          },
        ],
        password3: [
          {
            validator: validpassword3,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: this.$t("account.pwdRule1"),
            trigger: "blur",
          },
        ],
        emailCurrentPwd: [
          {
            validator: validEmailPassword1,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: this.$t("account.pwdRule1"),
            trigger: "blur",
          },
        ],
        emailNewPwd: [
          {
            validator: validEmailPassword2,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: this.$t("account.pwdRule1"),
            trigger: "blur",
          },
        ],
        emailReinsertPwd: [
          {
            validator: validEmailPassword3,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: this.$t("account.pwdRule1"),
            trigger: "blur",
          },
        ],
      },
      submitReady1: false,
      submitReady2: false,
      submitReady3: false,
      submitReady4: false,
      errorFlag: false,
      errorMsg: "",
      btnMsg: this.$t("account.getCode"),
      sendFlag: true, // 可以发送短信
      myInterval: null,
      myInterval1: null,
      codeImg: "",
      codeImg1: "",
      imgToken: "",
      count: 5,
      lineIndex: 1,
      showCodeImg: false,
      typeid: null,
    };
  },
  mounted() {
    this.getimgCode1();
  },
  methods: {
    sendSms() {
      let typeid = this.typeid;
      var params = {};
      this.showCodeImg = false;
      if (this.accountType === "phone") {
        // 判断是否在倒计时中
        if (typeid == 2 || typeid == 4) {
          if (!this.phoneCaptcha) {
            this.errorMsg = this.$t("login.pleaseInsertGraph");
            this.errorFlag = true;
            return;
          }
          // 无需校验手机号码
          this.$apis.account
            .getSmsSend(
              "",
              "",
              typeid,
              this.$utils.token("joy_jct"),
              this.phoneCaptcha
            )
            .then((res) => {
              if (res.data.code == 0) {
                this.timing();
              } else {
                this.getimgCode1();
                this.handleErrorCode(res.data);
              }
            });
        } else if (typeid == 3) {
          if (!this.phoneCaptcha) {
            this.errorMsg = this.$t("login.pleaseInsertGraph");
            this.errorFlag = true;
            return;
          }
          // 需要校验手机号码
          this.$apis.account
            .getSmsSend(
              this.ruleForm2.phone,
              this.selected.id,
              typeid,
              this.$utils.token("joy_jct"),
              this.phoneCaptcha
            )
            .then((res) => {
              if (res.data.code == 0) {
                this.timing();
              } else {
                this.getimgCode1();
                this.handleErrorCode(res.data);
              }
            });
        }
      } else if (this.accountType === "email") {
        if (!this.emailCaptcha) {
          this.errorMsg = this.$t("login.pleaseInsertGraph");
          this.errorFlag = true;
          return;
        }
        params = {
          user: typeid == 3 ? this.ruleForm2.email : "",
          type: typeid == 2 ? 0 : typeid == 3 ? 2 : typeid == 4 ? 1 : "",
        };
        // 无需校验手机号码
        this.$apis.account
          .sendEmailCode(params.user, params.type, this.emailCaptcha)
          .then((res) => {
            if (res.data.code == 0) {
              this.timing();
            } else {
              this.getimgCode1();
              this.handleErrorCode(res.data);
            }
          });
      }
    },
    closeModal() {
      this.showCodeImg = false;
      this.phoneCaptcha = "";
      this.emailCaptcha = "";
      this.typeid = null;
    },
    // 獲取圖形驗證碼
    getimgCode1(tag) {
      if (tag === "switch") {
        if (this.lineIndex < 20) {
          ++this.lineIndex;
        } else {
          return;
        }
      }
      if (this.accountType === "email") {
        // 邮箱
        this.codeImg1 = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/web/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      } else if (this.accountType === "phone") {
        // 手机号
        this.codeImg1 = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomain}/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      } else {
        // 邮箱和手机号码
        this.codeImg1 = `//l1${
          this.lineIndex % 3 === 0 ? 3 : this.lineIndex % 3
        }-${this.$siteConfig.captchaImgDomainGlobal}/web/captcha?region=${
          this.$regionIndex
        }&t=${new Date().getTime()}`;
      }
    },

    // 獲取圖形驗證碼
    getImgCode() {
      this.$apis.common.getCaptchaCode(5).then((res) => {
        if (res.data.code === 0) {
          var imgUrl = res.data.data.img_url.split("//");
          this.codeImg =
            window.location.protoco + "//" + imgUrl[imgUrl.length - 1];
          this.imgToken = res.data.data.img_token;
        }
      });
    },
    // 错误码提示信息处理
    handleErrorCode(data) {
      if (data.code == -101) {
        this.$router.push({
          path: "/login",
          query: {
            redirect: location.href,
          },
        });
        return false;
      }
      if (this.$area !== "komoe-sea") {
        this.errorMsg = data.message;
      } else {
        const popText = this.getResCode(data.code);
        this.errorMsg = popText ? popText : this.$t("account.serverError");
      }

      this.errorFlag = true;
    },
    // 倒计时
    timing() {
      // 倒计时
      this.sendFlag = false;
      let i = 60;
      this.myInterval = setInterval(() => {
        if (i < 1) {
          this.clearTiming();
        } else {
          this.btnMsg = this.$t("account.resend") + i + "s";
          --i;
        }
      }, 1000);
    },
    // 返回倒计时
    timingBack() {
      let i = 5;
      this.myInterval1 = setInterval(() => {
        if (i < 1) {
          clearInterval(this.myInterval1);
          this.backPage();
        } else {
          this.count = i;
          --i;
        }
      }, 1000);
    },
    backPage() {
      if (this.gameVersionStatus === 1) {
        this.$router.push({
          path: "/login",
          query: {
            type: "both",
            redirect: location.href,
          },
        });
      } else {
        this.$router.push({
          path: "/login",
          query: {
            redirect: location.href,
          },
        });
      }
    },
    clearTiming() {
      clearInterval(this.myInterval);
      this.btnMsg = this.$t("account.getCode");
      this.sendFlag = true;
    },
    // 获取手机动态码
    getCode(typeid) {
      // this.sendFlag控制是否可以发送短信
      if (this.sendFlag) {
        this.typeid = typeid;
        this.getimgCode1();
        this.showCodeImg = true;
        this.phoneCaptcha = "";
        this.emailCaptcha = "";
      }
    },
    checkSmsHandler(typeid) {
      var smsCode = "";
      if (this.accountType === "phone") {
        smsCode =
          typeid === 2
            ? this.ruleForm1.code
            : typeid === 4
            ? this.ruleForm3.code
            : "";
      } else if (this.accountType === "email") {
        smsCode =
          typeid === 2
            ? this.ruleForm1.emailCode
            : typeid === 4 || typeid === 5
            ? this.ruleForm3.emailCode
            : "";
      }
      var handleChecked = (res) => {
        if (res.data.code == 0) {
          if (this.$area === "komoe-sea") {
            if (res.data.data && !res.data.data.result) {
              alert("Verify code failed!");
              return;
            }
          }
          this.clearTiming();
          this.getimgCode1();
          this.emailCaptcha = "";
          this.phoneCaptcha = "";
          if (this.changeTab) {
            // 切换表单1和2
            this.form1 = false;
            this.form2 = true;
          } else {
            this.form3 = false;
            this.form4 = true;
          }
        } else {
          this.handleErrorCode(res.data);
        }
      };

      if (this.submitReady1 || this.submitReady3) {
        if (this.accountType === "phone") {
          // 短信校验接口
          this.$apis.account
            .getSmsCheck("", "", typeid, smsCode, this.$utils.token("joy_jct"))
            .then((res) => {
              handleChecked(res);
            });
        } else if (this.accountType === "email") {
          if (this.$area === "komoe-sea") {
            // komoe东南亚邮箱账号修改密码，图形验证码
            this.$apis.common
              .verifyEmailCaptcha(this.imgToken, smsCode)
              .then((res) => {
                handleChecked(res);
              });
          } else {
            // 邮箱验证码校验接口
            this.$apis.account.checkEmailCode(smsCode).then((res) => {
              handleChecked(res);
            });
          }
        }
      }
    },
    checkSms(typeid, smsCode) {
      if (typeid == 2) {
        // 手机号
        this.$refs.ruleForm1.validate().then(() => {
          this.checkSmsHandler(typeid, smsCode);
        });
      } else if (typeid == 4) {
        // 邮箱
        this.$refs.ruleForm3.validate().then(() => {
          this.checkSmsHandler(typeid, smsCode);
        });
      } else if (typeid == 5) {
        // komoe东南亚邮箱
        this.$refs.ruleForm3.validate().then(() => {
          this.checkSmsHandler(typeid, smsCode);
        });
      }
    },
    submitNewTel() {
      if (this.accountType === "phone") {
        // 更换绑定手机号码
        this.$apis.account
          .changeTel(
            this.ruleForm1.code,
            this.ruleForm2.phone,
            this.selected.id,
            this.ruleForm2.code,
            this.$utils.token("joy_jct")
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.clearTiming();
              this.form2 = false;
              this.result1 = true;
            } else {
              this.handleErrorCode(res.data);
            }
          });
      } else {
        // 更换绑定邮箱号码
        this.$apis.account
          .changeEmail(this.ruleForm2.email, this.ruleForm2.code)
          .then((res) => {
            if (res.data.code == 0) {
              this.clearTiming();
              this.form2 = false;
              this.result1 = true;
            } else {
              this.handleErrorCode(res.data);
            }
          });
      }
    },
    newPwdRequest() {
      // if (this.accountType === "phone") {
      //   this.$apis.account
      //     .changePwd(
      //       this.ruleForm3.code,
      //       this.ruleForm4.password1,
      //       this.ruleForm4.password2,
      //       this.ruleForm4.password3,
      //       this.$utils.token("joy_jct")
      //     )
      //     .then(res => {
      //       if (res.data.code == 0) {
      //         this.form4 = false;
      //         this.result2 = true;
      //       } else {
      //         this.handleErrorCode(res.data.code);
      //       }
      //     });
      // } else {
      var changeEmailPwd = (pwd1, pwd2, pwd3) => {
        this.$apis.account
          .changeEmailPwd(this.ruleForm3.emailCode, pwd1, pwd2, pwd3)
          .then((res) => {
            if (res.data.code == 0) {
              this.form4 = false;
              this.result2 = true;
              // 日本平台重置密码之后删除cookie已清除登录态
              store.dispatch("logoutSlient");
            } else {
              this.handleErrorCode(res.data);
            }
          });
      };

      var changeNewEmailPwd = (pwd1, pwd2, pwd3) => {
        this.$apis.account
          .changeNewEmailPwd(this.ruleForm3.emailCode, pwd1, pwd2, pwd3, true)
          .then((res) => {
            if (res.data.code == 0) {
              this.form4 = false;
              this.result2 = true;
              // 日本平台重置密码之后删除cookie已清除登录态
              store.dispatch("logoutSlient");
              if (this.$area === "komoe") {
                this.timingBack();
              }
            } else {
              this.handleErrorCode(res.data);
            }
          });
      };

      var handleEncrypt = (res, password) => {
        var jsencrypt = new JSEncrypt();
        jsencrypt.setPublicKey(res.data.data.rsa_key);
        var output = jsencrypt.encrypt(res.data.data.hash + password);
        var code = res.data.code;
        if (code === 0) {
          return output;
        } else {
          this.handleErrorCode(res.data);
        }
      };

      if (this.$region === "komoe") {
        this.$apis.findpwd.getResetPublicKey(true).then((res) => {
          let pwd1, pwd2, pwd3;
          if (this.$area === "komoe-sea") {
            (pwd1 = handleEncrypt(res, this.ruleForm4.emailCurrentPwd)),
              (pwd2 = handleEncrypt(res, this.ruleForm4.emailNewPwd)),
              (pwd3 = handleEncrypt(res, this.ruleForm4.emailReinsertPwd));
          } else {
            (pwd1 = handleEncrypt(res, this.ruleForm4.password1)),
              (pwd2 = handleEncrypt(res, this.ruleForm4.password2)),
              (pwd3 = handleEncrypt(res, this.ruleForm4.password3));
          }
          changeNewEmailPwd(pwd1, pwd2, pwd3);
        });
      } else {
        this.$apis.findpwd.getResetPublicKey().then((res) => {
          var pwd1 = handleEncrypt(res, this.ruleForm4.emailCurrentPwd),
            pwd2 = handleEncrypt(res, this.ruleForm4.emailNewPwd),
            pwd3 = handleEncrypt(res, this.ruleForm4.emailReinsertPwd);
          changeEmailPwd(pwd2, pwd3, pwd1);
        });
      }

      // }
    },
    submitNewPwd() {
      this.$refs.ruleForm4.validate().then(() => {
        this.newPwdRequest();
      });
    },
    checkAllInputs1() {
      this.submitReady1 =
        this.accountType === "phone"
          ? this.ruleForm1.defaultPhone && this.ruleForm1.code
            ? true
            : false
          : this.ruleForm1.defaultEmail && this.ruleForm1.emailCode
          ? true
          : false;
    },
    checkAllInputs2() {
      this.submitReady2 =
        this.accountType === "phone"
          ? this.ruleForm2.phone && this.ruleForm2.code
            ? true
            : false
          : this.ruleForm2.email && this.ruleForm2.code
          ? true
          : false;
    },
    checkAllInputs3() {
      this.submitReady3 =
        this.accountType === "phone"
          ? this.ruleForm3.defaultPhone && this.ruleForm3.code
            ? true
            : false
          : this.ruleForm3.defaultEmail && this.ruleForm3.emailCode
          ? true
          : false;
    },
    checkAllInputs4() {
      this.submitReady4 =
        this.accountType === "phone"
          ? this.ruleForm4.password1 &&
            this.ruleForm4.password2 &&
            this.ruleForm4.password3
            ? true
            : false
          : this.ruleForm4.emailCurrentPwd &&
            this.ruleForm4.emailCurrentPwd &&
            this.ruleForm4.emailReinsertPwd
          ? true
          : false;
    },
    selectOption(item) {
      this.selected = item;
    },
    changeModel(id) {
      this.clearTiming();
      this.changeTab = id;
    },
    getCountryList() {
      this.$apis.common.getCountryList().then((res) => {
        if (res.data.code == 0) {
          this.codeList = res.data.data.map((item) => {
            return {
              id: item.id,
              val: "+" + item.country_id,
            };
          });
          this.selected.val = "+" + res.data.data[0].country_id;
          this.selected.id = res.data.data[0].id;
        }
      });
    },
    // 获取用户信息
    getUserInfo() {
      this.$apis.common
        .getUserInfo(this.$utils.token("joy_jct"))
        .then((res) => {
          if (res.data.code == 0) {
            if (this.accountType === "phone") {
              this.ruleForm1.defaultPhone =
                this.$t("account.primaryMob") + res.data.data.tel;
              this.ruleForm3.defaultPhone =
                this.$t("account.primaryMob") + res.data.data.tel;
            } else {
              this.ruleForm1.defaultEmail = res.data.data.email;
              this.ruleForm3.defaultEmail = res.data.data.email;
            }
          } else if (res.data.code == -101) {
            this.$router.push({
              path: "/login",
              query: {
                redirect: location.href,
              },
            });
          }
        });
    },
    // 关闭错误信息弹窗
    closeErrorModal() {
      this.errorFlag = false;
    },
  },
  watch: {
    ruleForm1: {
      handler: function() {
        this.checkAllInputs1();
      },
      deep: true,
    },
    ruleForm2: {
      handler: function() {
        this.checkAllInputs2();
      },
      deep: true,
    },
    ruleForm3: {
      handler: function() {
        this.checkAllInputs3();
      },
      deep: true,
    },
    ruleForm4: {
      handler: function() {
        this.checkAllInputs4();
      },
      deep: true,
    },
  },
  created() {
    // 获取用户信息
    this.getUserInfo();

    if (this.accountType === "phone") {
      this.getCountryList();
    }

    // 东南亚帐号修改密码直接输入旧密码与新密码，无需第一步的验证
    if (this.$region === "komoe") {
      // this.getImgCode()
      this.form3 = false;
      this.form4 = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/scss/common.scss";
@import "./scss/index.scss";
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.login-box {
  position: relative;
  top: 60px;
  margin: 0 auto;
  padding: 40px 80px;
  width: 380px;
  height: 580px;
  background-color: #fff;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
  border-radius: 12px;
}
.login-tit {
  margin-bottom: 40px;
  font-size: 32px;
  text-align: center;
}
.tip-line {
  font-size: 12px;
  line-height: 18px;
  .tip-link {
    color: #2da2d4;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
.slice-box {
  position: relative;
  height: 16px;
  margin-top: 40px;
  font-size: 12px;
  text-align: center;
  .s-txt {
    position: relative;
    z-index: 2;
    display: inline-block;
    padding: 0 10px;
    color: #ccc;
    background-color: #fff;
  }
  &:after {
    position: absolute;
    top: 7px;
    left: 0;
    content: "";
    width: 100%;
    border-top: 1px solid #eee;
  }
}
.login-box-bot {
  margin-top: 40px;
  text-align: center;
  .login-btn {
    display: inline-block;
    margin-bottom: 10px;
    width: 170px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    border-radius: 20px;
    background-color: #ccc;
    cursor: not-allowed;
    &.allowed {
      background-color: #2da2d4;
      cursor: pointer;
    }
  }
}
.mask {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.tit-border {
  display: inline-block;
  width: 4px;
  height: 20px;
  margin-top: -4px;
  margin-right: 6px;
  border-radius: 2px;
  vertical-align: middle;
  background-color: #2da2d4;
}
.close-icon {
  float: right;
  cursor: pointer;
  transition: transform 0.3s;
  &:hover {
    transform: rotate(90deg);
  }
}
.pop-modal {
  margin-top: 214px;
  margin-left: 50%;
  width: 400px;
  height: 270px;
  background-color: #fff;
  border-radius: 12px;
  transform: translateX(-50%);
  .modal-head {
    padding: 20px;
    border-bottom: 1px solid #ddd;
    color: #444;
  }
}
.modal-form {
  padding: 40px 30px;
  display: flex;
  flex-flow: column;
}
.radio-box {
  position: relative;
  display: inline-block;
  margin-top: -2px;
  margin-right: 10px;
  width: 10px;
  height: 10px;
  border: 2px solid #ccc;
  border-radius: 3px;
  vertical-align: middle;
  cursor: pointer;
  &:hover {
    border-color: #2da2d4;
  }
  &:after {
    box-sizing: content-box;
    content: "";
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 5px;
    left: 4px;
    position: absolute;
    top: 2px;
    transform: rotate(45deg) scaleY(0);
    width: 4px;
    transition: transform 0.1s ease-in 0.05s;
    transform-origin: center;
  }
  &.checked {
    width: 14px;
    height: 14px;
    border: none;
    background-color: #2da2d4;
    &:after {
      transform: rotate(45deg) scaleY(1);
    }
  }
}
</style>

<style lang="scss">
.account-page {
  .changePwdTitle {
    font-size: 28px;
    color: #444444;
    text-align: center;
    margin-bottom: 50px;
  }
  .change-pwd {
    width: 468px;
    .el-form {
      top: 0;
    }
    .top-nav {
      margin-bottom: 86px;
    }
  }
  .handBack {
    color: #2da2d4;
    cursor: pointer;
  }
  &.sea {
    .bui-container {
      .top-nav i {
        width: 254px;
      }
    }
    .change-pwd {
      width: 616px;
      left: 50%;
      margin: 0;
      transform: translateX(-40%);
      .el-form {
        top: 0;
      }
    }
    .change-maintitle {
      // position: absolute;
      // width: 616px;
      // left: 50%;
      // margin-left: -100px;
      margin: 0 auto;
      width: 1200px;
    }
    .tab-menu {
      padding: 30px;
      height: 170px;
      top: 175px;
      border: none;
      border-radius: 10px;
      background: #fbfbfb;
      box-sizing: border-box;
    }
    .change-pwd {
      top: 180px;
    }
    .el-form-item {
      // margin-left: 175px;
      .el-col {
        &:first-child {
          padding-right: 25px;
          text-align: right;
          font-weight: bold;
        }
      }
    }
    .el-form-item__error {
      left: 205px;
    }
    .btn-next {
      margin-top: 42px;
    }
    .code-tip {
      width: 188px;
      &.email-code {
        width: 112px;
        top: 6px;
        right: 6px;
        height: 36px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 17px;
        overflow: hidden;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .phone-input {
    .el-input__inner {
      padding-left: 95px;
    }
    &.jp {
      .el-input__inner {
        padding-left: 15px;
      }
    }
  }
  .el-form-item__label {
    line-height: 50px;
  }
  .el-form-item__content {
    line-height: 50px;
  }
  .el-form-item {
    position: relative;
    margin-bottom: 20px;
  }
  &.jp {
    .el-form-item {
      margin-bottom: 50px;
    }
  }
  .code-area {
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 2;
    width: 85px;
    height: 30px;
    padding-left: 15px;
    line-height: 30px;
    border-right: 1px solid #eee;
    text-align: center;
    .el-input__inner {
      height: 30px;
      line-height: 30px;
      border: none;
      color: #2da2d4;
    }
  }
  .el-input__inner {
    height: 50px;
    line-height: 50px;
    text-indent: 5px;
    border-width: 1px;
    border-radius: 25px;
    &:focus {
      border-color: #2da2d4;
    }
  }
  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-textarea__inner:focus {
    // border-color: #67c23a;
    border-color: #2da2d4;
  }

  .el-input.el-input__inner:focus {
    border-color: #2da2d4;
    background-color: #000;
  }

  .code-tip {
    position: absolute;
    top: 10px;
    right: 0;
    width: 112px;
    text-align: center;
    color: #2da2d4;
    line-height: 30px;
    border-left: 1px solid #eee;
    cursor: pointer;
    &.jp {
      width: 177px;
      color: #50bbe5;
    }
    &.modal-code {
      top: 6px;
      right: 6px;
      height: 34px;
      border: 2px solid rgba(0, 0, 0, 0.2);
      border-radius: 17px;
      overflow: hidden;
      &.jp {
        border-width: 1px;
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .el-form--label-left .el-form-item__label {
    font-size: 16px;
    color: #444444;
  }
  .el-form-item.is-required .el-form-item__label:before {
    display: none;
  }
  .el-select-dropdown__item.selected {
    color: #2da2d4;
  }
}
</style>

<style lang="scss">
.jp {
  .el-input.is-disabled .el-input__inner {
    background-color: #eee;
  }
}
</style>
